import React, { useState, useEffect } from 'react'
import Sidebar from './Sidebar'
import DashboardSetup from './DashboardSetup'

const DashboardLayout: React.FC = () => {
  const [activePage, setActivePage] = useState('setup')
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  // Check if viewport is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen)
  }

  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false)
  }

  const renderMainContent = () => {
    switch (activePage) {
      case 'setup':
        return <DashboardSetup />
      default:
        return <DashboardSetup />
    }
  }

  return (
    <div className="dashboard-layout">
      <Sidebar
        activePage={activePage}
        onPageChange={setActivePage}
        isMobile={isMobile}
        isOpen={isMobileSidebarOpen}
        onClose={closeMobileSidebar}
      />
      <main className="dashboard-main">
        <div className="dashboard-main-content">{renderMainContent()}</div>
      </main>

      {/* Mobile Menu Button */}
      {isMobile && (
        <button
          className="mobile-menu-button"
          onClick={toggleMobileSidebar}
          aria-label="Open navigation menu"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 12H21M3 6H21M3 18H21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </div>
  )
}

export default DashboardLayout
